import type {
  ReactElement,
  ReactNode,
} from 'react';
import styled from 'styled-components';
import type {
  TagPresetType,
} from '@n3/css-base';

import { Breadcrumbs } from '../Breadcrumbs';
import type {
  BreadcrumbType,
} from '../Breadcrumbs';
import { PageTitle } from '../PageTitle';
import {
  Tabs,
  renderLinkTab,
} from '../Tabs';
import type {
  TabType,
  TabId,
} from '../Tabs';

const StyledWrapper = styled.div(({
  theme: {
    indents,
  },
}) => ({
  paddingBottom: indents.INDENT_8,
}));

export const StyledTitle = styled.div(({
  theme: {
    indents,
  },
}) => ({
  marginTop: indents.INDENT_7,
}));

export const StyledHeaderBlockWrapper = styled.div(({
  theme: {
    indents,
  },
}) => ({
  marginTop: indents.INDENT_3,
  marginBottom: indents.INDENT_2,
}));

const StyledTabsWrapper = styled.div(({
  theme: {
    indents,
  },
}) => ({
  marginTop: indents.INDENT_1,
  marginBottom: indents.INDENT_7,
}));

export type NestedShowLayoutProps = {
  /**
   * Массив объектов хлебных крошек
   */
  breadcrumbs: BreadcrumbType[];
  /**
   * Заголовок страницы
   */
  title: ReactNode;
  /**
   * Блок действий у заголовка сущности (кнопки и т.п.)
   */
  actionsBlock?: ReactNode;
  /**
   * Блок, выводящийся между заголовком страницы и табами
   */
  headerBlock?: ReactNode;
  /**
   * Табы
   */
  tabs: TabType[];
  /**
   * id выбранного таба
   */
  currentTab: TabId;
  /**
   * Статус
   */
  status?: ReactNode;
  /**
   * Цвет тэга статуса
   */
  statusColor?: TagPresetType;
  /**
   * Содержимое страницы
   */
  children?: ReactNode;
};

export function NestedShowLayout({
  breadcrumbs,
  title,
  actionsBlock = undefined,
  status = undefined,
  statusColor = undefined,
  headerBlock = undefined,
  tabs,
  currentTab,
  children = undefined,
}: NestedShowLayoutProps): ReactElement {
  return (
    <StyledWrapper>
      <Breadcrumbs
        breadcrumbs={breadcrumbs}
      />

      <StyledTitle>
        <PageTitle
          pageType="parent"
          status={status}
          statusColor={statusColor}
          actionsBlock={actionsBlock}
        >
          {title}
        </PageTitle>
      </StyledTitle>

      {
        headerBlock && (
          <StyledHeaderBlockWrapper>
            {headerBlock}
          </StyledHeaderBlockWrapper>
        )
      }

      <StyledTabsWrapper>
        <Tabs
          tabs={tabs}
          renderTab={renderLinkTab}
          current={currentTab}
        />
      </StyledTabsWrapper>

      {children}
    </StyledWrapper>
  );
}
